import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { KnowledgeItem } from '@api/models/knowledge-item.model';
import { ModalComponent } from '@ui/modal/modal.component';
import { MODAL_REF, ModalRef, ModalService } from '@ui/modal/modal.service';

@Component({
  selector: 'app-knowledge-item-preview-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  template: `
    <ui-modal
      [title]="item.title"
      [hideSubmit]="true"
      [cancelText]="'Sluiten'"
      [size]="'xl'"
      (close)="closeModal()"
    >
      @if (embedUrl) {
        <div class="aspect-video w-full overflow-hidden rounded bg-black">
          <iframe
            class="h-full w-full"
            [src]="embedUrl"
            title="YouTube-video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            referrerpolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      } @else {
        <p class="text-sm text-slate-600">Deze video kan niet worden afgespeeld.</p>
      }
    </ui-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KnowledgeItemPreviewModalComponent {
  item!: KnowledgeItem;

  private modalRef = inject(MODAL_REF);
  private modalService = inject(ModalService);
  private sanitizer = inject(DomSanitizer);

  get embedUrl(): SafeResourceUrl | null {
    if (!this.item?.embed_url) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.item.embed_url);
  }

  closeModal() {
    this.modalService.close(this.modalRef as ModalRef<unknown>);
  }
}
